mutation TravelAuthorizationPoGeneration(
  $input: TravelAuthorizationPoGenerationInput!
) {
  travelAuthorizationPoGeneration(input: $input) {
    processRequests {
      id
      rowTimestamp
      reference
      message
      isWarning
      isSuccess
      isFail
    }
  }
}
